(function(){
  var ua = navigator.userAgent || '';
  /* TikTok, Instagram, Facebook and other in-app webviews hand taps to the
     native player no matter what the page does. There, background loops are
     replaced with a still frame, so nothing is openable. */
  var inApp = /BytedanceWebview|musical_ly|TikTok|Bytelo|Instagram|FBAN|FBAV|FB_IAB|Line\/|KAKAOTALK|Snapchat|Pinterest/i.test(ua);

  function still(v){
    var url = v.getAttribute('data-still');
    if (!url) { v.remove(); return; }
    var img = document.createElement('img');
    img.src = url;
    img.alt = '';
    img.setAttribute('aria-hidden','true');
    if (v.className) img.className = v.className;
    if (v.getAttribute('style')) img.setAttribute('style', v.getAttribute('style'));
    if (v.parentNode) v.parentNode.replaceChild(img, v);
  }

  function kick(v){ if (v.paused){ var p = v.play(); if (p && p.catch) p.catch(function(){}); } }

  function init(){
    if (inApp) {
      [].forEach.call(document.querySelectorAll('video[data-bgloop]'), still);
      return;
    }
    var vids = document.querySelectorAll('video[loop]');
    if (!('IntersectionObserver' in window)) { [].forEach.call(vids, kick); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) kick(e.target);
        else if (!e.target.paused) e.target.pause();
      });
    }, { rootMargin: '120px' });
    [].forEach.call(vids, function(v){ io.observe(v); kick(v); });
    setTimeout(function(){ [].forEach.call(document.querySelectorAll('video[loop]'), function(v){
      var r = v.getBoundingClientRect();
      if (r.top < innerHeight + 120 && r.bottom > -120) kick(v);
    }); }, 1200);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
